import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=7c3d59f2&scoped=true&"
import script from "./ViewDocument.vue?vue&type=script&lang=js&"
export * from "./ViewDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d59f2",
  null
  
)

export default component.exports